<svg class="sidebar-icon" [class.is-open]="open" viewBox="0 0 400 416" fill="none" aria-hidden="true" focusable="false">
  <!-- Panel relleno del estado abierto; se extiende bajo el contorno para no dejar juntas visibles. -->
  <path class="sidebar-icon__panel" d="M61 31H139V385H61C38.9 385 21 367.1 21 345V71C21 48.9 38.9 31 61 31Z" fill="currentColor" />

  <g class="sidebar-icon__bars">
    <rect x="50" y="80" width="60" height="20" rx="10" />
    <rect x="50" y="119" width="60" height="20" rx="10" />
    <rect x="50" y="159" width="60" height="20" rx="10" />
  </g>

  <rect x="21" y="31" width="353" height="354" rx="40" stroke="currentColor" stroke-width="20" />
  <path d="M139 31V385" stroke="currentColor" stroke-width="20" />
</svg>
